import { useContext, useMemo, useState, useEffect } from "react";
import FusePageCarded from "src/app/@core/@fuse/FusePageCarded.FullWidth";
import useThemeMediaQuery from "@fuse/hooks/useThemeMediaQuery";
import { DomainContext } from "src/app/@core/@contexts/domain.context";
import {
  ModuleContext,
  initialModuleData,
  moduleDataContext,
} from "src/app/@core/@contexts/module.context";
import FuseUtils from "@fuse/utils/FuseUtils";
import { UserManagementTable, ContactsHeader } from "./userManagementTable";
import { isUoN } from "src/app/@core/common";

export const UserManagementPage = () => {
  const [store, setStore] = useState(initialModuleData);
  const [gvItems, setGvItems] = useState([]);
  const [retailers, setRetailers] = useState([]);

  const { api, spinner } = useContext(DomainContext);
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down("lg"));
  const [searchCriteria, setSearchCriteria] = useState({});

  /** Load Data */
  const loadData = async () => {
    try {
      spinner.show();

      const items = await api.retailerApi.getDropdownItems();
      setRetailers([
        { itemID: FuseUtils.generateGUID(), id: 0, name: "" },
        ...items,
      ]);

      const result = await api.contactApi.getAllSP();
      if (isUoN(result)) return;

      const firstName = searchCriteria?.firstName;
      const lastName = searchCriteria?.lastName;
      const retailerName = searchCriteria?.retailerName;

      const filtered = result.filter((x) => {
        const fn = x.firstName;
        const ln = x.lastName;
        const rn = x.retailerName;

        const bFirstName =
          !firstName ||
          (fn &&
            firstName &&
            fn.trim().toLowerCase() === firstName.trim().toLowerCase());

        const bLastName =
          !lastName ||
          (ln &&
            lastName &&
            ln.trim().toLowerCase() === lastName.trim().toLowerCase());

        const bRetailerName =
          !retailerName ||
          (rn &&
            retailerName &&
            rn.trim().toLowerCase() === retailerName.trim().toLowerCase());

        return bFirstName && bLastName && bRetailerName;
      });

      moduleDataContext.setGvItems(filtered);
      moduleDataContext.moduleGvData(filtered);
    } catch (err) {
      console.log(err);
    } finally {
      spinner.hide();
    }
  };

  /** Module Context */
  const contextObj = useMemo(() => {
    moduleDataContext.bootstrap(store, setStore);
    moduleDataContext.setGvItems = setGvItems;
    moduleDataContext.loadModelDataFunc = loadData;
    moduleDataContext.searchCriteria = searchCriteria;
    moduleDataContext.setSearchCriteria = setSearchCriteria;
    moduleDataContext.spinner = spinner;
    return moduleDataContext;
  }, [store]);

  useEffect(() => {
    loadData();
  }, [searchCriteria]);

  return (
    <ModuleContext.Provider value={contextObj}>
      <FusePageCarded
        header={<ContactsHeader />}
        content={
          <UserManagementTable gvItems={gvItems} retailers={retailers} />
        }
        scroll={isMobile ? "normal" : "normal"}
      />
    </ModuleContext.Provider>
  );
};
